const applySmartCrop = (photoUrl, width, height) => {
  if (!photoUrl) {
    return '';
  }

  if (!width || !height) {
    return photoUrl;
  }

  if (photoUrl.indexOf('media-api.xogrp.com') === -1) {
    return photoUrl;
  }
  const transformationPrefix = photoUrl.indexOf('~') === -1 ? '~' : '-';

  return `${photoUrl}${transformationPrefix}sc_${width}.${height}`;
};

export default applySmartCrop;
